export default __webpack_public_path__ + "static/media/hospitality1.52f5b37c.webp";